const Timeline = () => {
	return <div>Timeline</div>;
};

export default Timeline;
